const modulo = (value, length) => {
  return ((value % length) + length) % length
}

export default modulo
